import { render, staticRenderFns } from "./myIncome.vue?vue&type=template&id=0950a393&"
import script from "./myIncome.vue?vue&type=script&lang=js&"
export * from "./myIncome.vue?vue&type=script&lang=js&"
import style0 from "./myIncome.vue?vue&type=style&index=0&id=0950a393&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports